import { useEffect, useState } from 'react';
import { Button, Form, InputGroup, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { fetchCustomers } from '../../api/customer';

const Customers = () => {
    const navigate = useNavigate();
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [limit] = useState(10);
    const [hasNext, setHasNext] = useState(false);
    const [search, setSearch] = useState('');
    const [query, setQuery] = useState('');
    const [typingTimeout, setTypingTimeout] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const res = await fetchCustomers(page, limit, query);
                setCustomers(res.data.data);
                setHasNext(res.data.data.length === limit);
            } catch (err) {
                console.error('Failed to fetch customers:', err);
                if (err.status === 401) {
                    alert('Session expired. Please log in again.');
                    localStorage.removeItem('ums_user');
                    navigate('/login');
                }
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [page, limit, query]);

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        setPage(1);

        if (typingTimeout) clearTimeout(typingTimeout);

        setTypingTimeout(
            setTimeout(() => {
                setQuery(value.trim());
            }, 400)
        );
    };

    const handleNext = () => setPage((p) => p + 1);
    const handlePrev = () => setPage((p) => Math.max(1, p - 1));

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 className="mb-0">Customer Profiles</h3>
                <Button variant="primary" onClick={() => navigate('/crm/new-application')}>
                    New Application
                </Button>
            </div>

            <Form className="mb-3">
                <InputGroup style={{ maxWidth: 300 }}>
                    <Form.Control
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={handleSearchChange}
                    />
                </InputGroup>
            </Form>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <>
                    <Table bordered hover responsive>
                        <thead className="table-light">
                            <tr>
                                <th>#</th>
                                <th>Account #</th>
                                <th>Name</th>
                                <th>Address</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customers.map((c, i) => (
                                <tr
                                    key={c.id}
                                    onClick={() => navigate(`/crm/customers/${c.id}`)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>{(page - 1) * limit + i + 1}</td>
                                    <td>{c.accountNumber}</td>
                                    <td>{c.firstName} {c.lastName}</td>
                                    <td>{c.address}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                        <Button disabled={page === 1} onClick={handlePrev}>
                            Previous
                        </Button>
                        <span>Page {page}</span>
                        <Button disabled={!hasNext} onClick={handleNext}>
                            Next
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default Customers;
